import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col m-2" };
const _hoisted_2 = { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_3 = { class: "py-3" };
const _hoisted_4 = { class: "text-primary font-semibold pb-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = { class: "text-primary text-sm font-light" };
const _hoisted_7 = { class: "flex flex-row" };
const _hoisted_8 = { class: "flex flex-row border-gray-300 mt-2 border-solid border rounded" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-check mr-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DefaultLanguageSelector = _resolveComponent("DefaultLanguageSelector");
    const _component_Button = _resolveComponent("Button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('settings.globalTitle')), 1),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('settings.DefaultLanguage')), 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('settings.DefaultLanguageSubtitle')), 1),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    (_ctx.settings.defaultLanguage)
                        ? (_openBlock(), _createBlock(_component_DefaultLanguageSelector, {
                            key: 0,
                            defaultLanguage: _ctx.settings.defaultLanguage,
                            onSelectedLanguage: _ctx.changeLanguage
                        }, null, 8, ["defaultLanguage", "onSelectedLanguage"]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _createVNode(_component_Button, {
            onClick: _ctx.pushSettings,
            class: "-ml-0.5 w-max",
            colored: ""
        }, {
            default: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.buttons.save')), 1)
            ]),
            _: 1
        }, 8, ["onClick"])
    ]));
}
